import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useAuth } from "~/Hooks/useAuth";
import { post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { fields } from "../constants";
import { useHomePageCarouselDocumentDetails } from "./HomePageCarousel.hook";

export const AddEditHomePageCarousel = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const {
    data: editData,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchEditData,
  } = useHomePageCarouselDocumentDetails(query.get("editId") || "");

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditData();
    }
  }, [query.get("editId"), query.get("id")]);
  console.log("dataById", dataById);

  const AwardsFormConfig: FormConfig = {
    initialValues: {
      title: decodeHTML(dataById ? dataById.payload.title : editData ? editData?.title : ""),

      // field_airport: decodeHTML(dataById ? dataById.payload.field_airport : editData ? editData?.field_airport : ""),

      start_date: decodeHTML(dataById ? dataById.payload.start_date : editData ? editData?.start_date : ""),

      end_date: decodeHTML(dataById ? dataById.payload.end_date : editData ? editData?.end_date : ""),

      status: decodeHTML(
        dataById
          ? dataById.payload?.status?.toLowerCase() === "true"
          : editData
            ? editData?.status?.toLowerCase() === "true"
            : false
      ),

      images: decodeHTML(
        dataById?.payload?.images
          ? [
              {
                uid: "-1",
                name: "Homepage.png",
                status: "done",
                url: dataById?.payload?.images,
              },
            ]
          : editData?.images
            ? [
                {
                  uid: "-1",
                  name: "Homepage.png",
                  status: "done",
                  url: editData?.images,
                },
              ]
            : ""
      ),
    },
    fields: fields.homePageCarousel,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let imageKeys: any = ["images"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    const formattedData = {
      ...data,
      ...(data.start_date && { start_date: data.start_date.replace("T", " ") }),
      ...(data.end_date && { end_date: data.end_date.replace("T", " ") }),
    };

    const payload = {
      action: action,
      method: method,
      module: "Advertisement",
      subModule: `homePageCarousel`,
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editData?.id || dataById?.payload?.id }),
        ...formattedData,
        status: String(data.status),
      },
      status: status,
    };
    console.log(payload, "payload");
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
          // refetchDocument();
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      // loading={isLoadingData}
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Homepage Carousel`}
      showBack
    >
      <DynamicForm
        isLoading={isLoadingData || drilldownLoading}
        config={AwardsFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            // `${query.get("editId") || query.get("type") === 'update'}` ? `${eramanHost}/api/home-page-banners-list-crud-api/${editData?.id || dataById?.payload?.id}` : `${eramanHost}/api/create/home-page-banners-list-crud-api`,
            // `${query.get("editId") || query.get("type") === 'update' ? "UPDATE" : "CREATE"}`,
            // `${query.get("editId") || query.get("type") === 'update' ? "PATCH" : "POST"}`,

            `${query.get("editId") ? `${eramanHost}/api/home-page-banners-list-crud-api/${editData?.id || dataById?.payload?.id}` : `${eramanHost}/api/create/home-page-banners-list-crud-api`}`,
            `${query.get("editId") ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </ContentWrapper>
  );
};
